module.exports = __webpack_public_path__ + "static/media/octave.f378c341.png";